<template>
	<template v-for="relation in similarRelationsList" :key="relation.Code">
		<div
			v-if="relation?.Items?.length"
			class="flex gap-2 items-center flex-col"
		>
			<span class="font-heldane text-xl">
				{{ relation.Name || "SIMILAR PRODUCTS" }}
			</span>
			<Carousel
				:slides="relation.Items || []"
				:type-of-slide="ItemType.PRODUCT"
				:blok="{ number_of_slides_to_show: '4', show_arrows: true }"
			/>
		</div>
	</template>
</template>

<script setup lang="ts">
import type { SimplifiedProductRelations } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { ItemType, ProductPrefix } from "~/utils/constants";

const { relations } = storeToRefs(useProductStore());

const similarRelationsList = computed(() => {
	const productRelations = (relations.value ||
		[]) as SimplifiedProductRelations[];
	return productRelations.filter(
		(relation) => !relation.Code.includes(ProductPrefix.PACKAGE_PRODUCT)
	);
});
</script>
